const productTypeIdMap = {
  174: 'txt_canvas',
  173: 'txt_poster',
} as { [key: number]: string };

const getProductTypeTranslationKey = (productTypeId: number) => productTypeIdMap[productTypeId];

export default getProductTypeTranslationKey;
